module.exports = __webpack_public_path__ + "static/github-9295157598c30867cf10c621f6292112.png";